const ProjectTitleIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <rect
        x="2"
        y="7"
        width="20"
        height="15"
        rx="1"
        stroke="#14508c"
        strokeWidth="1.3"
        fill="none"
      />
      <path
        d="M6 7V4a1 1 0 011-1h10a1 1 0 011 1v3"
        stroke="#14508c"
        strokeWidth="1.3"
        fill="none"
      />
    </svg>
  );
};

export default ProjectTitleIcon;
